import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'jurisdiction-grid',
  templateUrl: './jurisdiction-grid.component.html',
  styleUrls: ['./jurisdiction-grid.component.css']
})
export class JurisdictionGridComponent implements OnInit {
  title="Jurisdictions";

  itemsPerPage: number=5;
  currentPage: number=1;
  JurisdictionDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  Jurt_id : number;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }
   ngOnInit() { 
    this.GetJurisdictionDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetJurisdictionDetails(itemsPerPage:any,pageNo:any){
  //alert('Inside');
  this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.UserService.GetJurisdictionDetails(itemsPerPage,pageNo);
    this.data.subscribe(
      (response: any) => {
        this.JurisdictionDetailsList = response.JurisdictionModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        console.log('Jurisdiction Deatils');
        console.log(this.JurisdictionDetailsList);    
        document.getElementById('loader-spinner').style.display = "none";
      },(error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  delete(Jurt_id){
    swal({
       title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
        if (result.value) {
        this.data = this.UserService.DeleteJurisdiction(Jurt_id);
        this.data.subscribe(
         (response: any) => {
          this.GetJurisdictionDetails(this.itemsPerPage, 1)
            //alert('Inside');;          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }      
      ); 
    } 
    })
    }

    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetJurisdictionDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetJurisdictionDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchJurisdiction(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.JurisdictionModel.length!=0){              
            this.JurisdictionDetailsList = data.JurisdictionModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/masters/Jurisdiction/jurisdiction-grid/jurisdiction-grid.component.ts